// ONE implementation, two runtimes — the same function objects the edge
// functions use, so the app and the server can never disagree about what one
// orderable package is or whether its stored facts conflict. (Same pattern as
// vendorState.mjs / canonicalItemCost.mjs; do not add a browser copy.)
export {
  PACKAGE_BASIS_VERSION,
  PACKAGE_BASIS_WARNINGS,
  QTY_TOLERANCE_EXACT,
  QTY_TOLERANCE_CONVERTED,
  NORMALIZED_COST_TOLERANCE,
  BASIS_AI_CONFIDENCE_THRESHOLD,
  confirmedInterpretationQty,
  convertBasisQuantity,
  extractPackageMeasurements,
  hasPackageBasisConflict,
  isOrderReadyOption,
  itemCountUnitPhysicalBasis,
  storedQtyIsFallbackDefault,
  packageBasisFingerprint,
  purchaseUnitIdentityForNeed,
  resolveOrderPackageBasis,
  resolveNeedToPackageBasis,
  storedComparisonFacts,
  validateComparisonAgainstBasis,
  validatePackageConsistency,
} from '../../../supabase/functions/_shared/packageBasis.mjs';
